import React from "react";
import DashboardPPIC from "../../components/DashboardPPIC/DashboardPPIC";
import EditLogo from "../../Assets/editLogo.png";
import { constMesinSP, bulan, constMesinSPTim2 } from "../../util/constant";
import { useDashboard } from "./useDashboard";
import "./Dashboard.css";
import DeleteIcon from "../../Assets/delete_icon.png";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import moment from "moment";
import RefreshIcon from "../../Assets/refresh-icon.png";
import { validateRole } from "../../util/utilFunction";
import OperatorCard from "../../components/OperatorCard/OperatorCard";
import ScanLogo from "../../Assets/scan-logo.png";
import { normalizeRoles, hasRole } from "../../util/utilFunction";

const Dashboard = () => {
  const {
    dataUser,
    ref,
    dateDashboard,
    setDateDashboard,
    shiftDashboard,
    setShiftDashboard,
    historyDataOperator,
    handleFormChange,
    handleKirimEditOperator,
    isEdit,
    setIsEdit,
    handleKirimEditAdmin,
    popUpSubmit,
    setPopUpSubmit,
    dataLaporanOperatorQc,
    popUpDelete,
    handleDeleteLaporan,
    handleSetDataDelete,
    dataDelete,
    handleCancelDelete,
    dataLaporanPasangKaret,
    handleDeleteLaporanPasangKaret,
    handleSetDataDeletePasangKaret,
    dataDeletePasangKaret,
    popUpDeletePasangKaret,
    handleCancelDeletePasangKaret,
    dataQc,
    handleChangeMesin,
    handleFormChangePasangKaret,
    subMenu,
    setSubMenu,
    setDateMonitoringSP,
    dateMonitoringSP,
    isEditSP,
    setIsEditSP,
    handleFormChangeSP,
    handleKirimEditSP,
    exportBulanan,
    popUpLaporanBulananSP,
    setPopUpLaporanBulananSP,
    bulanExportSP,
    setBulanExportSP,
    tahunExportSP,
    setTahunExportSP,
    isOn,
    filterBagian,
    setFilterBagian,
    dataTemp,
    handleReset,
    filterProduk,
    setFilterProduk,
    filterProdukSelect,
    filterMesinInjeksi,
    setFilterMesinInjeksi,
    filterMesinSelect,
    dataTempMesinInjeksi,
    filterMesinOperator,
    dataTempMesinOperator,
    target,
    setTarget,
    setIsRefresh,
    dataLaporanPasangStiker,
    handleFormChangePasangSticker,
    dataDeletePasangSticker,
    setDataDeletePasangSticker,
    popUpDeletePasangSticker,
    setPopUpDeletePasangSticker,
    handleSetDataDeletePasangSticker,
    handleCancelDeletePasangSticker,
    handleDeleteLaporanPasangSticker,
    handleScan,
    popUpScan,
    setPopUpScan,
    keteranganScan,
    setKeteranganScan,
    errMsg,
    listTopPlate,
    filterMesinSp,
    setFilterMesinSp,
    isPopUpExportLaporanSp,
    setIsPopUpExportLaporanSp,
    handleExportLaporanSp,
    listNewsLetter,
    popUpNewsLetter,
    setPopUpNewsLetter,
  } = useDashboard();

  // ---------- Hak akses ----------
  // Tab Approval
  const isProduksiAdmin = hasRole(dataUser, "produksi_admin");

  // Tab Produksi + Second Process
  const canSeeTabs = hasRole(
    dataUser,
    "super_user",
    "ppic_admin",
    "produksi_admin",
    "qc_admin"
  );

  // Tab Produksi: tiga tampilan berbeda (rantai if / else if, urutan penting)
  const isProduksiMonitor = hasRole(
    dataUser,
    "super_user",
    "ppic_admin",
    "produksi_leader",
    "mold_user",
    "produksi_admin",
    "qc_admin"
  );
  const isProduksiUser = hasRole(dataUser, "produksi_user");
  const isQcUser = hasRole(dataUser, "qc_user");

  // Ikon scan di tampilan monitor: dulu "bukan mold_user",
  // sekarang daftar role yang boleh (mold_user dikeluarkan)
  const canScan = hasRole(
    dataUser,
    "super_user",
    "ppic_admin",
    "produksi_leader",
    "produksi_admin",
    "qc_admin"
  );

  // Tab Second Process
  const canPilihBagian = hasRole(dataUser, "ppic_admin", "super_user");
  const canLaporanBulanan = hasRole(
    dataUser,
    "pr_admin",
    "sp_admin",
    "produksi_admin",
    "super_user",
    "document_control"
  );
  const canLaporanSp = canLaporanBulanan || hasRole(dataUser, "qc_admin");
  const isPrAdmin = hasRole(dataUser, "pr_admin");

  const sortData =
    dataTempMesinOperator &&
    dataTempMesinOperator.sort(function (a, b) {
      if (Number(a.mesin) < Number(b.mesin)) {
        return -1;
      }
      if (Number(a.mesin) > Number(b.mesin)) {
        return 1;
      }
      return 0;
    });

  const sortDataMonitoring =
    dataTempMesinInjeksi &&
    dataTempMesinInjeksi.sort(function (a, b) {
      if (Number(a.mesin) < Number(b.mesin)) {
        return -1;
      }
      if (Number(a.mesin) > Number(b.mesin)) {
        return 1;
      }
      return 0;
    });
  const sortDataQc =
    dataLaporanOperatorQc &&
    dataLaporanOperatorQc.sort(function (a, b) {
      if (Number(a.mesin) < Number(b.mesin)) {
        return -1;
      }
      if (Number(a.mesin) > Number(b.mesin)) {
        return 1;
      }
      return 0;
    });
  const sortDataPasangKaret =
    dataLaporanPasangKaret &&
    dataLaporanPasangKaret.sort(function (a, b) {
      if (Number(a.mesin) < Number(b.mesin)) {
        return -1;
      }
      if (Number(a.mesin) > Number(b.mesin)) {
        return 1;
      }
      return 0;
    });
  const sortDataPasangStiker =
    dataLaporanPasangStiker &&
    dataLaporanPasangStiker.sort(function (a, b) {
      if (Number(a.mesin) < Number(b.mesin)) {
        return -1;
      }
      if (Number(a.mesin) > Number(b.mesin)) {
        return 1;
      }
      return 0;
    });
  const sortDataSP =
    dataTemp &&
    dataTemp.sort(function (a, b) {
      if (Number(a.mesin) < Number(b.mesin)) {
        return -1;
      }
      if (Number(a.mesin) > Number(b.mesin)) {
        return 1;
      }
      return 0;
    });
  const sortMesin =
    filterMesinSelect &&
    filterMesinSelect.sort(function (a, b) {
      if (Number(a) < Number(b)) {
        return -1;
      }
      if (Number(a) > Number(b)) {
        return 1;
      }
      return 0;
    });
  const sortMesinOperator =
    filterMesinOperator &&
    filterMesinOperator.sort(function (a, b) {
      if (Number(a) < Number(b)) {
        return -1;
      }
      if (Number(a) > Number(b)) {
        return 1;
      }
      return 0;
    });

  const handleResetFilter = () => {
    setFilterMesinInjeksi("Pilih Mesin");
    setTarget("Pilih Target");
  };

  return (
    <div className="container_dashboard">
      {((listNewsLetter && listNewsLetter.berita.length > 0) ||
        (listNewsLetter && listNewsLetter.keterlambatan.length > 0) ||
        (listNewsLetter && listNewsLetter.sia.length > 0)) &&
      dataUser.tim === 1 &&
      popUpNewsLetter ? (
        <div className="hide-desktop-newsletter">
          <PopUpComponent scroll>
            {listNewsLetter && listNewsLetter.berita.length > 0 ? (
              <>
                {listNewsLetter.berita &&
                  listNewsLetter.berita.map((data) => {
                    return (
                      <div style={{ marginTop: "12px" }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <p
                            className="font-14-mobile-newsletter animated-text"
                            style={{
                              fontWeight: 550,
                              margin: "0 6px 0 0",
                              lineHeight: "18px",
                            }}
                          >
                            {data && data.title.toUpperCase()}
                          </p>
                        </div>
                        <p
                          className="font-14-newsletter"
                          style={{ marginLeft: "12px" }}
                        >
                          &#x2022;&nbsp;{data && data.subTitle}
                        </p>
                      </div>
                    );
                  })}
              </>
            ) : (
              ""
            )}
            {listNewsLetter && listNewsLetter.keterlambatan.length > 0 ? (
              <>
                {listNewsLetter.keterlambatan &&
                  listNewsLetter.keterlambatan.map((data) => {
                    return (
                      <div style={{ marginTop: "24px" }}>
                        <div>
                          <p
                            className="font-14-mobile-newsletter mark"
                            style={{
                              fontWeight: 550,
                              margin: "0 6px 6px 0",
                              color: "#E43636",
                              lineHeight: "18px",
                              textAlign: "center",
                            }}
                          >
                            {data && data.title.toUpperCase()}
                          </p>
                          <p
                            className="font-14-mobile-newsletter mark"
                            style={{
                              fontWeight: 550,
                              margin: "0 6px 6px 0",
                              color: "#E43636",
                              lineHeight: "18px",
                              fontSize: "10.5px",
                              textAlign: "center",
                            }}
                          >
                            {data && data.subTitle}
                          </p>
                        </div>
                        <div
                          style={{
                            width: "0px",
                            minWidth: "100%",
                            overflow: "auto",
                          }}
                        >
                          <table style={{ width: "100%" }}>
                            <tr>
                              <th
                                className="font-14-mobile-newsletter"
                                style={{
                                  textAlign: "left",
                                  padding: "12px 6px",
                                }}
                              >
                                No.
                              </th>
                              <th
                                className="font-14-mobile-newsletter"
                                style={{
                                  textAlign: "left",
                                  padding: "12px 6px",
                                }}
                              >
                                Tgl
                              </th>
                              <th
                                className="font-14-mobile-newsletter"
                                style={{
                                  textAlign: "left",
                                  padding: "12px 6px",
                                }}
                              >
                                Nama
                              </th>
                              <th
                                className="font-14-mobile-newsletter"
                                style={{
                                  textAlign: "left",
                                  padding: "12px 6px",
                                }}
                              >
                                Bagian
                              </th>
                            </tr>
                            {data.list.map((obj, index) => {
                              return (
                                <tr>
                                  <td
                                    className="font-12-mobile-newsletter"
                                    style={
                                      dataUser.id === obj.id
                                        ? {
                                            color: "red",
                                            textAlign: "left",
                                            padding: "12px 6px",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                          }
                                        : {
                                            textAlign: "left",
                                            padding: "12px 6px",
                                          }
                                    }
                                  >
                                    {index + 1}.
                                  </td>
                                  <td
                                    className="font-12-mobile-newsletter"
                                    style={
                                      dataUser.id === obj.id
                                        ? {
                                            color: "red",
                                            textAlign: "left",
                                            padding: "12px 6px",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                            whiteSpace: "nowrap",
                                          }
                                        : {
                                            textAlign: "left",
                                            padding: "12px 6px",
                                            whiteSpace: "nowrap",
                                          }
                                    }
                                  >
                                    {obj && obj.tglTerlambat}
                                  </td>
                                  <td
                                    className="font-12-mobile-newsletter"
                                    style={
                                      dataUser.id === obj.id
                                        ? {
                                            color: "red",
                                            textAlign: "left",
                                            padding: "12px 6px",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                          }
                                        : {
                                            textAlign: "left",
                                            padding: "12px 6px",
                                          }
                                    }
                                  >
                                    {obj && obj.name}
                                  </td>
                                  <td
                                    className="font-12-mobile-newsletter"
                                    style={
                                      dataUser.id === obj.id
                                        ? {
                                            color: "red",
                                            textAlign: "left",
                                            padding: "12px 6px",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                          }
                                        : {
                                            textAlign: "left",
                                            padding: "12px 6px",
                                          }
                                    }
                                  >
                                    {obj && obj.bagian}
                                  </td>
                                </tr>
                              );
                            })}
                          </table>
                        </div>
                      </div>
                    );
                  })}
              </>
            ) : (
              ""
            )}
            {listNewsLetter && listNewsLetter.sia.length > 0 ? (
              <>
                <p
                  style={{
                    margin: 0,
                    borderBottom: "2px dotted black",
                    color: "transparent",
                  }}
                >
                  a
                </p>
                {listNewsLetter.sia &&
                  listNewsLetter.sia.map((data) => {
                    return (
                      <div style={{ marginTop: "24px" }}>
                        <div>
                          <p
                            className="font-14-mobile-newsletter mark"
                            style={{
                              fontWeight: 550,
                              margin: "0 6px 6px 0",
                              color: "#E43636",
                              lineHeight: "18px",
                              textAlign: "center",
                            }}
                          >
                            {data && data.title}
                          </p>
                          <p
                            className="font-14-mobile-newsletter mark"
                            style={{
                              fontWeight: 550,
                              margin: "0 6px 6px 0",
                              color: "#E43636",
                              lineHeight: "18px",
                              fontSize: "10.5px",
                              textAlign: "center",
                            }}
                          >
                            {data && data.subTitle}
                          </p>
                        </div>
                        <div
                          style={{
                            width: "0px",
                            minWidth: "100%",
                            overflow: "auto",
                          }}
                        >
                          <table style={{ width: "100%" }}>
                            <tr>
                              <th
                                className="font-14-mobile-newsletter"
                                style={{
                                  textAlign: "left",
                                  padding: "12px 6px",
                                }}
                              >
                                No.
                              </th>
                              <th
                                className="font-14-mobile-newsletter"
                                style={{
                                  textAlign: "left",
                                  padding: "12px 6px",
                                }}
                              >
                                Nama
                              </th>
                              <th
                                className="font-14-mobile-newsletter"
                                style={{
                                  textAlign: "left",
                                  padding: "12px 6px",
                                }}
                              >
                                Bagian
                              </th>
                              <th
                                className="font-14-mobile-newsletter"
                                style={{
                                  textAlign: "center",
                                  padding: "12px 6px",
                                }}
                              >
                                S
                              </th>
                              <th
                                className="font-14-mobile-newsletter"
                                style={{
                                  textAlign: "center",
                                  padding: "12px 6px",
                                }}
                              >
                                I
                              </th>
                              <th
                                className="font-14-mobile-newsletter"
                                style={{
                                  textAlign: "center",
                                  padding: "12px 6px",
                                }}
                              >
                                A
                              </th>
                            </tr>
                            {data.list.map((obj, index) => {
                              return (
                                <tr>
                                  <td
                                    className="font-12-mobile-newsletter"
                                    style={
                                      dataUser.id === obj.id
                                        ? {
                                            color: "red",
                                            textAlign: "left",
                                            padding: "12px 6px",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                          }
                                        : {
                                            textAlign: "left",
                                            padding: "12px 6px",
                                          }
                                    }
                                  >
                                    {index + 1}.
                                  </td>
                                  <td
                                    className="font-12-mobile-newsletter"
                                    style={
                                      dataUser.id === obj.id
                                        ? {
                                            color: "red",
                                            textAlign: "left",
                                            padding: "12px 6px",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                          }
                                        : {
                                            textAlign: "left",
                                            padding: "12px 6px",
                                          }
                                    }
                                  >
                                    {obj && obj.name}
                                  </td>

                                  <td
                                    className="font-12-mobile-newsletter"
                                    style={
                                      dataUser.id === obj.id
                                        ? {
                                            color: "red",
                                            textAlign: "left",
                                            padding: "12px 6px",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                          }
                                        : {
                                            textAlign: "left",
                                            padding: "12px 6px",
                                          }
                                    }
                                  >
                                    {obj && obj.bagian}
                                  </td>
                                  <td
                                    className="font-12-mobile-newsletter"
                                    style={
                                      dataUser.id === obj.id
                                        ? {
                                            color: "red",
                                            textAlign: "center",
                                            padding: "12px 6px",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                          }
                                        : {
                                            textAlign: "center",
                                            padding: "12px 6px",
                                          }
                                    }
                                  >
                                    {obj.s ? obj.s : 0}
                                  </td>
                                  <td
                                    className="font-12-mobile-newsletter"
                                    style={
                                      dataUser.id === obj.id
                                        ? {
                                            color: "red",
                                            textAlign: "center",
                                            padding: "12px 6px",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                          }
                                        : {
                                            textAlign: "center",
                                            padding: "12px 6px",
                                          }
                                    }
                                  >
                                    {obj.i ? obj.i : 0}
                                  </td>
                                  <td
                                    className="font-12-mobile-newsletter"
                                    style={
                                      dataUser.id === obj.id
                                        ? {
                                            color: "red",
                                            textAlign: "center",
                                            padding: "12px 6px",
                                            fontWeight: "600",
                                            fontSize: "14px",
                                          }
                                        : {
                                            textAlign: "center",
                                            padding: "12px 6px",
                                          }
                                    }
                                  >
                                    {obj.a ? obj.a : 0}
                                  </td>
                                </tr>
                              );
                            })}
                          </table>
                        </div>
                      </div>
                    );
                  })}
              </>
            ) : (
              ""
            )}
            <button
              className="btn-close-newsletter"
              onClick={() => setPopUpNewsLetter(false)}
            >
              Tutup
            </button>
          </PopUpComponent>
        </div>
      ) : (
        ""
      )}
      {isPopUpExportLaporanSp ? (
        <PopUpComponent>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <select
              defaultValue="Pilih No Mesin"
              onChange={(e) => setBulanExportSP(e.target.value)}
              className="input_select_memo_ppic"
              style={{ width: "48%" }}
              value={bulanExportSP}
            >
              <option selected disabled>
                Pilih Bulan
              </option>
              {bulan &&
                bulan.map((data) => (
                  <option value={data.value}>{data.name}</option>
                ))}
            </select>
            <select
              defaultValue="Pilih No Mesin"
              onChange={(e) => setTahunExportSP(e.target.value)}
              className="input_select_memo_ppic"
              style={{ width: "48%" }}
              value={tahunExportSP}
            >
              <option selected disabled>
                Pilih Tahun
              </option>
              <option value="2022">2022</option>
              <option value="2023">2023</option>
              <option value="2024">2024</option>
              <option value="2025">2025</option>
              <option value="2026">2026</option>
            </select>
          </div>
          <br />
          <div className="wrapper_button_submit_popup">
            <div className="wrapper_button_submit_popup">
              <button
                className="button_popup"
                onClick={() => setIsPopUpExportLaporanSp(false)}
              >
                Cancel
              </button>
              <button
                className="button_popup background_red"
                onClick={() => handleExportLaporanSp()}
              >
                Export
              </button>
            </div>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpLaporanBulananSP ? (
        <PopUpComponent>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <select
              defaultValue="Pilih No Mesin"
              onChange={(e) => setBulanExportSP(e.target.value)}
              className="input_select_memo_ppic"
              style={{ width: "48%" }}
              value={bulanExportSP}
            >
              <option selected disabled>
                Pilih Bulan
              </option>
              {bulan &&
                bulan.map((data) => (
                  <option value={data.value}>{data.name}</option>
                ))}
            </select>
            <select
              defaultValue="Pilih No Mesin"
              onChange={(e) => setTahunExportSP(e.target.value)}
              className="input_select_memo_ppic"
              style={{ width: "48%" }}
              value={tahunExportSP}
            >
              <option selected disabled>
                Pilih Tahun
              </option>
              <option value="2022">2022</option>
              <option value="2023">2023</option>
              <option value="2024">2024</option>
              <option value="2025">2025</option>
              <option value="2026">2026</option>
            </select>
          </div>
          <br />
          <div className="wrapper_button_submit_popup">
            <div className="wrapper_button_submit_popup">
              <button
                className="button_popup"
                onClick={() => setPopUpLaporanBulananSP(false)}
              >
                Cancel
              </button>
              <button
                className="button_popup background_red"
                onClick={() => exportBulanan()}
              >
                Export
              </button>
            </div>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpDeletePasangKaret ? (
        <PopUpComponent>
          <p>
            Apakah Kamu Yakin ingin menghapus laporan Pasang Karet{" "}
            <b>{dataDeletePasangKaret && dataDeletePasangKaret.mesin}</b> ?
          </p>
          <div className="wrapper_button_submit_popup">
            <div className="wrapper_button_submit_popup">
              <button
                className="button_popup"
                onClick={() => handleCancelDeletePasangKaret()}
              >
                Cancel
              </button>
              <button
                className="button_popup background_red"
                onClick={() => handleDeleteLaporanPasangKaret()}
              >
                Yakin
              </button>
            </div>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpDeletePasangSticker ? (
        <PopUpComponent>
          <p>
            Apakah Kamu Yakin ingin menghapus laporan Pasang Sticker{" "}
            <b>{dataDeletePasangSticker && dataDeletePasangSticker.mesin}</b> ?
          </p>
          <div className="wrapper_button_submit_popup">
            <div className="wrapper_button_submit_popup">
              <button
                className="button_popup"
                onClick={() => handleCancelDeletePasangSticker()}
              >
                Cancel
              </button>
              <button
                className="button_popup background_red"
                onClick={() => handleDeleteLaporanPasangSticker()}
              >
                Yakin
              </button>
            </div>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpDelete ? (
        <PopUpComponent>
          <p>
            Apakah Kamu Yakin ingin menghapus laporan Mesin{" "}
            <b>{dataDelete && dataDelete.mesin}</b> ?
          </p>
          <div className="wrapper_button_submit_popup">
            <div className="wrapper_button_submit_popup">
              <button
                className="button_popup"
                onClick={() => handleCancelDelete()}
              >
                Cancel
              </button>
              <button
                className="button_popup background_red"
                onClick={() => handleDeleteLaporan()}
              >
                Yakin
              </button>
            </div>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpSubmit ? (
        <PopUpComponent>
          <p>Data Kamu Telah Dikirim!</p>
          <div className="wrapper_button_submit_popup">
            <button
              className="button_popup background_red"
              onClick={() => setPopUpSubmit(false)}
            >
              OK
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      {popUpScan ? (
        <PopUpComponent>
          <div ref={ref} id="qr" style={{ marginBottom: "12px" }}></div>
          <p style={{ color: "red" }}>{errMsg}</p>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <img
              style={{
                width: "42px",
                cursor: "pointer",
              }}
              src={ScanLogo}
              onClick={() => handleScan()}
            />
            <textarea
              style={{
                width: "100%",
                margin: "12px 0",
                height: "48px",
                fontSize: "12px",
                fontFamily: "sans-serif",
                resize: "none",
              }}
              value={keteranganScan}
              onChange={(e) => setKeteranganScan(e.target.value)}
              placeholder="Catatan"
            />
          </div>
          <div
            className="wrapper_button_submit_popup"
            style={{ justifyContent: "end" }}
          >
            <button
              className="button_popup background_red"
              onClick={() => setPopUpScan(false)}
            >
              Tutup
            </button>
          </div>
        </PopUpComponent>
      ) : (
        ""
      )}
      <div className="wrapper_sub_menu_history" style={{ margin: 0 }}>
        {isProduksiAdmin ? (
          <p
            className={
              subMenu === "Approval"
                ? "sub_menu_history border_active_history"
                : "sub_menu_history"
            }
            onClick={() => setSubMenu("Approval")}
          >
            Approval
          </p>
        ) : (
          ""
        )}
        {canSeeTabs ? (
          <>
            <p
              className={
                subMenu === "Produksi"
                  ? "sub_menu_history border_active_history"
                  : "sub_menu_history"
              }
              onClick={() => setSubMenu("Produksi")}
            >
              Produksi
            </p>
            <p
              className={
                subMenu === "SP"
                  ? "sub_menu_history border_active_history"
                  : "sub_menu_history"
              }
              onClick={() => setSubMenu("SP")}
            >
              Second Process
            </p>
          </>
        ) : (
          ""
        )}
      </div>

      {subMenu === "Produksi" ? (
        <>
          {isProduksiMonitor ? (
            <>
              <div className="sticky_filter">
                <div style={{ marginRight: "12px" }}>
                  <p className="p-margin-subtittle-dashboard">Pilih Shift</p>
                  <select
                    className="input_select_filter"
                    value={shiftDashboard}
                    onChange={(e) => setShiftDashboard(e.target.value)}
                  >
                    <option
                      selected={shiftDashboard === "Pilih Shift"}
                      disabled
                    >
                      Pilih Shift
                    </option>
                    <option value="1">Shift 1</option>
                    <option value="2">Shift 2</option>
                    <option value="3">Shift 3</option>
                  </select>
                </div>
                <div className="margin_right_27_qc">
                  <p className="p-margin-subtittle-dashboard">Pilih Tanggal</p>
                  <input
                    type="date"
                    className="date_pick_dashboard"
                    value={dateDashboard}
                    onChange={(e) => setDateDashboard(e.target.value)}
                  />
                </div>
                <div style={{ marginRight: "12px" }}>
                  <p className="p-margin-subtittle-dashboard">Pilih Mesin</p>
                  <select
                    className="input_select_filter"
                    value={filterMesinInjeksi}
                    onChange={(e) => setFilterMesinInjeksi(e.target.value)}
                  >
                    <option selected={filterBagian === "Pilih Mesin"} disabled>
                      Pilih Mesin
                    </option>
                    {sortMesin &&
                      sortMesin.map((obj) => (
                        <option value={obj}>{obj}</option>
                      ))}
                  </select>
                </div>

                <div style={{ marginRight: "12px" }}>
                  <p className="p-margin-subtittle-dashboard">Target</p>
                  <select
                    className="input_select_filter"
                    value={target}
                    onChange={(e) => setTarget(e.target.value)}
                  >
                    <option selected={filterBagian === "Pilih Target"} disabled>
                      Pilih Target
                    </option>
                    <option value="Target">Target</option>
                    <option value="Tidak">Tidak Target</option>
                  </select>
                </div>
                <div
                  className="margin_right_27_qc"
                  style={{ display: "flex", alignItems: "end" }}
                >
                  <p
                    className="btn_reset_search_inventory"
                    style={{ marginBottom: "12px" }}
                    onClick={() => handleResetFilter()}
                  >
                    Reset
                  </p>
                  <img
                    src={RefreshIcon}
                    alt="refresh"
                    style={{
                      width: "36px",
                      margin: "12px 0 12px 12px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setIsRefresh(true);
                    }}
                  />
                  {canScan ? (
                    <img
                      style={{
                        width: "42px",
                        cursor: "pointer",
                        margin: "12px 0px 12px 12px",
                      }}
                      src={ScanLogo}
                      onClick={() => setPopUpScan(true)}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <DashboardPPIC data={sortDataMonitoring} />
              {dataLaporanPasangKaret &&
              dataLaporanPasangKaret.length > 0 &&
              !isOn ? (
                <p className="title_inventory">Laporan Pasang Karet</p>
              ) : (
                ""
              )}
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                {sortDataPasangKaret &&
                  sortDataPasangKaret.map((obj) => {
                    const downtimePasangKaret = obj.downtime ? obj.downtime : 0;
                    const jumlahPasangKaret = obj.jumlah ? obj.jumlah : 0;
                    const aktualCavityPasangKaret = obj.aktualCavity
                      ? obj.aktualCavity
                      : 0;
                    const formula =
                      (28800 - downtimePasangKaret * 60) / jumlahPasangKaret;

                    return (
                      <div className="card_approval_top_plate">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <p
                            className="tittle-machine-dashboard"
                            style={{ width: "25%" }}
                          >
                            Mesin {obj.mesin}
                          </p>
                          <p style={{ fontWeight: "bold" }}>{obj.operator}</p>
                        </div>
                        <p style={{ fontWeight: "bold" }}>
                          {obj.produk} - {obj.warna}
                        </p>
                        {!isOn ? (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <div>
                              <p
                                style={
                                  Math.floor(
                                    ((28800 - obj.downtime * 60) / 43.2) *
                                      aktualCavityPasangKaret
                                  ) > jumlahPasangKaret
                                    ? { color: "red", fontWeight: "bold" }
                                    : { fontWeight: "bold" }
                                }
                              >
                                Target Produksi
                              </p>
                              <p
                                style={
                                  Math.floor(
                                    ((28800 - obj.downtime * 60) / 43.2) *
                                      aktualCavityPasangKaret
                                  ) > jumlahPasangKaret
                                    ? { color: "red" }
                                    : {}
                                }
                              >
                                {(
                                  ((28800 - obj.downtime * 60) / 43.2) *
                                  aktualCavityPasangKaret
                                ).toFixed(0)}
                              </p>
                            </div>
                            <div>
                              <p style={{ fontWeight: "bold" }}>Cycle Time</p>
                              <p>
                                {(formula * aktualCavityPasangKaret).toFixed(1)}{" "}
                                Detik
                              </p>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <div>
                            <p>
                              <b>Jumlah Pasang Karet</b>
                            </p>
                            <p>{obj.jumlah} Pcs</p>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <div style={{ width: "50%" }}>
                            <p>
                              <b>Downtime</b>
                            </p>
                            <p>{obj.downtime} Menit</p>
                          </div>
                          <div style={{ width: "40%" }}>
                            <p>
                              <b>Aktual Cavity</b>
                            </p>
                            <p>{obj.aktualCavity ? obj.aktualCavity : ""}</p>
                          </div>
                        </div>
                        <p className="font_bold">Keterangan</p>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: obj.keterangan.replace(/\n/g, "<br/>"),
                          }}
                          className="size-keterangan-dashboard"
                        />
                      </div>
                    );
                  })}
              </div>
              {dataLaporanPasangStiker && dataLaporanPasangStiker.length > 0 ? (
                <p className="title_inventory">Laporan Pasang Sticker</p>
              ) : (
                ""
              )}
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                {sortDataPasangStiker &&
                  sortDataPasangStiker.map((obj) => {
                    return (
                      <div className="card_approval_top_plate">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <p
                            className="tittle-machine-dashboard"
                            style={{ margin: "12px 0 6px 0" }}
                          >
                            Mesin {obj.mesin}
                          </p>
                          <p
                            style={{
                              fontWeight: "bold",
                              margin: "12px 0 6px 0",
                            }}
                          >
                            {obj.operator}
                          </p>
                        </div>
                        <p style={{ fontWeight: "bold", margin: "6px 0" }}>
                          {obj.produk} - {obj.warna}
                        </p>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: "wrap",
                          }}
                        >
                          <div>
                            <p style={{ margin: "6px 0" }}>
                              <b>Jumlah Pasang</b>
                            </p>
                            <p style={{ margin: "6px 0" }}>{obj.jumlah} Pcs</p>
                          </div>
                          <div>
                            <p style={{ margin: "6px 0" }}>
                              <b>NG Sticker</b>
                            </p>
                            <p style={{ margin: "6px 0" }}>
                              {obj && obj.reject} Pcs
                            </p>
                          </div>
                          <div>
                            <p style={{ margin: "6px 0" }}>
                              <b>NG Produk</b>
                            </p>
                            <p style={{ margin: "6px 0" }}>
                              {obj && obj.rejectProduk} Pcs
                            </p>
                          </div>
                          <div>
                            <p style={{ margin: "6px 0" }}>
                              <b>Downtime</b>
                            </p>
                            <p style={{ margin: "6px 0" }}>
                              {obj && obj.downtime} Menit
                            </p>
                          </div>
                        </div>
                        {obj?.kindOfReject?.length > 0 ? (
                          <div>
                            <p style={{ margin: "6px 0" }}>
                              <b>Ket. Reject Produk</b>
                            </p>
                            <table style={{ width: "100%" }}>
                              <tr>
                                <th style={{ position: "inherit" }}>Shift</th>
                                <th
                                  style={{
                                    position: "inherit",
                                    textAlign: "left",
                                    padding: "18px 0 18px 6px",
                                  }}
                                >
                                  Jenis Reject
                                </th>
                                <th
                                  style={{
                                    padding: "18px 6px",
                                    position: "inherit",
                                  }}
                                >
                                  Reject
                                </th>
                              </tr>
                              {obj.kindOfReject &&
                                obj.kindOfReject.map((ele, index) => {
                                  return (
                                    <tr
                                      style={
                                        index % 2 === 0
                                          ? {
                                              background: "white",
                                              fontSize: "12px",
                                            }
                                          : {
                                              background: "#f2f2f2",
                                              fontSize: "12px",
                                            }
                                      }
                                    >
                                      <td style={{ padding: "12px 6px" }}>
                                        {ele.shift}
                                      </td>
                                      <td
                                        style={{
                                          padding: "12px 0 12px 6px",
                                          textAlign: "left",
                                        }}
                                      >
                                        {ele.id}
                                      </td>
                                      <td style={{ padding: "12px 6px" }}>
                                        {ele.totalNG}
                                      </td>
                                    </tr>
                                  );
                                })}
                            </table>
                          </div>
                        ) : (
                          ""
                        )}
                        <p className="font_bold" style={{ margin: "6px 0" }}>
                          Keterangan
                        </p>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: obj.keterangan.replace(/\n/g, "<br/>"),
                          }}
                          className="size-keterangan-dashboard"
                        />
                      </div>
                    );
                  })}
              </div>
              {listTopPlate && listTopPlate.length > 0 ? (
                <p className="title_inventory">Laporan Pasang Top Plate</p>
              ) : (
                ""
              )}
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                {listTopPlate &&
                  listTopPlate.map((obj) => {
                    return (
                      <div className="card_approval_top_plate">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <p
                            className="tittle-machine-dashboard"
                            style={{ margin: "12px 0 6px 0" }}
                          >
                            Mesin {obj.mesin}
                          </p>
                          <p
                            style={{
                              fontWeight: "bold",
                              margin: "12px 0 6px 0",
                            }}
                          >
                            {obj.operator}
                          </p>
                        </div>
                        <p style={{ fontWeight: "bold", margin: "6px 0" }}>
                          {obj.produk}
                        </p>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <div>
                            <p style={{ margin: "6px 0" }}>
                              <b>Jumlah Pasang</b>
                            </p>
                            <p style={{ margin: "6px 0" }}>{obj.jumlah} Pcs</p>
                          </div>
                          <div>
                            <p style={{ margin: "6px 0" }}>
                              <b>Downtime</b>
                            </p>
                            <p style={{ margin: "6px 0" }}>
                              {obj.downtime} Menit
                            </p>
                          </div>
                        </div>
                        <p className="font_bold" style={{ margin: "6px 0" }}>
                          Keterangan
                        </p>
                        {obj.keterangan &&
                          obj.keterangan.split("\n").map((subStr) => {
                            return <p>{subStr}</p>;
                          })}
                      </div>
                    );
                  })}
              </div>
            </>
          ) : isProduksiUser ? (
            <>
              <div className="sticky_filter" style={{ display: "flex" }}>
                <div className="margin_right_27_qc">
                  <p className="p-margin-subtittle-dashboard">Pilih Shift</p>
                  <select
                    className="input_select_filter"
                    style={{ width: "72px" }}
                    value={shiftDashboard}
                    onChange={(e) => setShiftDashboard(e.target.value)}
                  >
                    <option
                      selected={shiftDashboard === "Pilih Shift"}
                      disabled
                    >
                      Pilih Shift
                    </option>
                    <option value="1">Shift 1</option>
                    <option value="2">Shift 2</option>
                    <option value="3">Shift 3</option>
                  </select>
                </div>
                <div className="margin_right_27_qc">
                  <p className="p-margin-subtittle-dashboard">Pilih Tanggal</p>
                  <input
                    type="date"
                    className="date_pick_dashboard"
                    value={dateDashboard}
                    onChange={(e) => setDateDashboard(e.target.value)}
                  />
                </div>
                <div style={{ marginRight: "12px" }}>
                  <p className="p-margin-subtittle-dashboard">Pilih Mesin</p>
                  <select
                    className="input_select_filter"
                    value={filterMesinInjeksi}
                    onChange={(e) => setFilterMesinInjeksi(e.target.value)}
                  >
                    <option selected={filterBagian === "Pilih Mesin"} disabled>
                      Pilih Mesin
                    </option>
                    {sortMesinOperator &&
                      sortMesinOperator.map((obj) => (
                        <option value={obj}>{obj}</option>
                      ))}
                  </select>
                </div>
              </div>
              <div
                className="container_card_approval_laporan"
                style={{ marginTop: "18px" }}
              >
                {sortData &&
                  sortData.map((data, index) => (
                    <OperatorCard
                      key={data.id ?? index}
                      data={data}
                      index={index}
                      dataUser={dataUser}
                      isEdit={isEdit}
                      setIsEdit={setIsEdit}
                      isOn={isOn}
                      handleFormChange={handleFormChange}
                    />
                  ))}
              </div>
              {dataLaporanPasangKaret &&
              dataLaporanPasangKaret.length > 0 &&
              !isOn ? (
                <p className="title_inventory">Laporan Pasang Karet</p>
              ) : (
                ""
              )}
              {sortDataPasangKaret &&
                sortDataPasangKaret.map((obj) => {
                  const downtimePasangKaret = obj.downtime ? obj.downtime : 0;
                  const jumlahPasangKaret = obj.jumlah ? obj.jumlah : 0;
                  const aktualCavityPasangKaret = obj.aktualCavity
                    ? obj.aktualCavity
                    : 0;
                  const formula =
                    (28800 - downtimePasangKaret * 60) / jumlahPasangKaret;

                  return (
                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                      <div className="card_approval_top_plate">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <p
                            className="tittle-machine-dashboard"
                            style={{ width: "25%" }}
                          >
                            Mesin {obj.mesin}
                          </p>
                          <p style={{ fontWeight: "bold" }}>{obj.operator}</p>
                        </div>
                        {!isOn ? (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <div>
                              <p
                                style={
                                  Math.floor(
                                    (28800 - downtimePasangKaret * 60) / formula
                                  ) > jumlahPasangKaret
                                    ? { color: "red", fontWeight: "bold" }
                                    : { fontWeight: "bold" }
                                }
                              >
                                Target Produksi
                              </p>
                              <p
                                style={
                                  Math.floor(
                                    (28800 - downtimePasangKaret * 60) / formula
                                  ) > jumlahPasangKaret
                                    ? { color: "red" }
                                    : {}
                                }
                              >
                                {Math.floor(
                                  (28800 - downtimePasangKaret * 60) / formula
                                )}
                              </p>
                            </div>
                            <div>
                              <p style={{ fontWeight: "bold" }}>Cycle Time</p>
                              <p>
                                {(formula * aktualCavityPasangKaret).toFixed(1)}{" "}
                                Detik
                              </p>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                        <p style={{ fontWeight: "bold" }}>
                          {obj.produk} - {obj.warna}
                        </p>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <div>
                            <p>
                              <b>Jumlah Pasang Karet</b>
                            </p>
                            <p>{obj.jumlah} Pcs</p>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <div style={{ width: "50%" }}>
                            <p>
                              <b>Downtime</b>
                            </p>
                            <p>{obj.downtime} Menit</p>
                          </div>
                          <div style={{ width: "40%" }}>
                            <p>
                              <b>Aktual Cavity</b>
                            </p>
                            <p>{obj.aktualCavity ? obj.aktualCavity : ""}</p>
                          </div>
                        </div>
                        <p className="font_bold">Keterangan</p>
                        {obj.keterangan &&
                          obj.keterangan.split("\n").map((subStr) => {
                            return <p>{subStr}</p>;
                          })}
                      </div>
                    </div>
                  );
                })}
              {dataLaporanPasangStiker && dataLaporanPasangStiker.length > 0 ? (
                <p className="title_inventory">Laporan Pasang Sticker</p>
              ) : (
                ""
              )}
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                {sortDataPasangStiker &&
                  sortDataPasangStiker.map((obj) => {
                    return (
                      <div className="card_approval_top_plate">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <p
                            className="tittle-machine-dashboard"
                            style={{ margin: "12px 0 6px 0" }}
                          >
                            Mesin {obj.mesin}
                          </p>
                          <p
                            style={{
                              fontWeight: "bold",
                              margin: "12px 0 6px 0",
                            }}
                          >
                            {obj.operator}
                          </p>
                        </div>
                        <p style={{ fontWeight: "bold", margin: "6px 0" }}>
                          {obj.produk} - {obj.warna}
                        </p>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: "wrap",
                          }}
                        >
                          <div>
                            <p style={{ margin: "6px 0" }}>
                              <b>Jumlah Pasang</b>
                            </p>
                            <p style={{ margin: "6px 0" }}>{obj.jumlah} Pcs</p>
                          </div>
                          <div>
                            <p style={{ margin: "6px 0" }}>
                              <b>NG Sticker</b>
                            </p>
                            <p style={{ margin: "6px 0" }}>
                              {obj && obj.reject} Pcs
                            </p>
                          </div>
                          <div>
                            <p style={{ margin: "6px 0" }}>
                              <b>NG Produk</b>
                            </p>
                            <p style={{ margin: "6px 0" }}>
                              {obj && obj.rejectProduk} Pcs
                            </p>
                          </div>
                          <div>
                            <p style={{ margin: "6px 0" }}>
                              <b>Downtime</b>
                            </p>
                            <p style={{ margin: "6px 0" }}>
                              {obj.downtime} Menit
                            </p>
                          </div>
                          {obj?.kindOfReject?.length > 0 ? (
                            <div>
                              <p style={{ margin: "6px 0" }}>
                                <b>Ket. Reject Produk</b>
                              </p>
                              <table>
                                <tr>
                                  <th style={{ position: "inherit" }}>Shift</th>
                                  <th
                                    style={{
                                      position: "inherit",
                                      textAlign: "left",
                                      padding: "18px 0 18px 6px",
                                    }}
                                  >
                                    Jenis Reject
                                  </th>
                                  <th
                                    style={{
                                      padding: "18px 6px",
                                      position: "inherit",
                                    }}
                                  >
                                    Reject
                                  </th>
                                </tr>
                                {obj.kindOfReject &&
                                  obj.kindOfReject.map((ele, index) => {
                                    return (
                                      <tr
                                        style={
                                          index % 2 === 0
                                            ? {
                                                background: "white",
                                                fontSize: "12px",
                                              }
                                            : {
                                                background: "#f2f2f2",
                                                fontSize: "12px",
                                              }
                                        }
                                      >
                                        <td style={{ padding: "12px 6px" }}>
                                          {ele.shift}
                                        </td>
                                        <td
                                          style={{
                                            padding: "12px 0 12px 6px",
                                            textAlign: "left",
                                          }}
                                        >
                                          {ele.id}
                                        </td>
                                        <td style={{ padding: "12px 6px" }}>
                                          {ele.totalNG}
                                        </td>
                                      </tr>
                                    );
                                  })}
                              </table>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        <p className="font_bold" style={{ margin: "6px 0" }}>
                          Keterangan
                        </p>
                        {obj.keterangan &&
                          obj.keterangan.split("\n").map((subStr) => {
                            return <p>{subStr}</p>;
                          })}
                      </div>
                    );
                  })}
              </div>
              {listTopPlate && listTopPlate.length > 0 ? (
                <p className="title_inventory">Laporan Pasang Top Plate</p>
              ) : (
                ""
              )}
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                {listTopPlate &&
                  listTopPlate.map((obj) => {
                    return (
                      <div className="card_approval_top_plate">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <p
                            className="tittle-machine-dashboard"
                            style={{ margin: "12px 0 6px 0" }}
                          >
                            Mesin {obj.mesin}
                          </p>
                          <p
                            style={{
                              fontWeight: "bold",
                              margin: "12px 0 6px 0",
                            }}
                          >
                            {obj.operator}
                          </p>
                        </div>
                        <p style={{ fontWeight: "bold", margin: "6px 0" }}>
                          {obj.produk}
                        </p>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <div>
                            <p style={{ margin: "6px 0" }}>
                              <b>Jumlah Pasang</b>
                            </p>
                            <p style={{ margin: "6px 0" }}>{obj.jumlah} Pcs</p>
                          </div>
                          <div>
                            <p style={{ margin: "6px 0" }}>
                              <b>Downtime</b>
                            </p>
                            <p style={{ margin: "6px 0" }}>
                              {obj.downtime} Menit
                            </p>
                          </div>
                        </div>
                        <p className="font_bold" style={{ margin: "6px 0" }}>
                          Keterangan
                        </p>
                        {obj.keterangan &&
                          obj.keterangan.split("\n").map((subStr) => {
                            return <p>{subStr}</p>;
                          })}
                      </div>
                    );
                  })}
              </div>
              {historyDataOperator &&
              historyDataOperator.length > 0 &&
              isEdit ? (
                <button
                  className="button_submit_memo"
                  onClick={() => handleKirimEditOperator()}
                >
                  Kirim
                </button>
              ) : (
                ""
              )}
            </>
          ) : isQcUser ? (
            <>
              <div style={{ display: "flex" }}>
                <div className="margin_right_27_qc">
                  <p>Pilih Shift</p>
                  <select
                    className="input_select_filter"
                    value={shiftDashboard}
                    onChange={(e) => setShiftDashboard(e.target.value)}
                  >
                    <option
                      selected={shiftDashboard === "Pilih Shift"}
                      disabled
                    >
                      Pilih Shift
                    </option>
                    <option value="1">Shift 1</option>
                    <option value="2">Shift 2</option>
                    <option value="3">Shift 3</option>
                  </select>
                </div>
                <div className="margin_right_27_qc">
                  <p>Pilih Tanggal</p>
                  <input
                    type="date"
                    className="date_pick_dashboard"
                    value={dateDashboard}
                    onChange={(e) => setDateDashboard(e.target.value)}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    alignItems: "end",
                  }}
                >
                  <img
                    src={RefreshIcon}
                    alt="refresh"
                    style={{
                      width: "36px",
                      margin: "12px 0 12px 0px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setIsRefresh(true);
                    }}
                  />
                  <img
                    style={{
                      width: "42px",
                      cursor: "pointer",
                      margin: "12px 0px 12px 12px",
                    }}
                    src={ScanLogo}
                    onClick={() => setPopUpScan(true)}
                  />
                </div>
              </div>
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                {sortDataQc &&
                  sortDataQc.map((data) => {
                    const isiPerKemasan = data.isiPerKemasan
                      ? data.isiPerKemasan
                      : 0;
                    const sisaShiftSebelumnya = data.sisaShiftSebelumnya
                      ? data.sisaShiftSebelumnya
                      : 0;
                    const jumlahBarangOK = data.jumlahBarang
                      ? data.jumlahBarang
                      : 0;

                    const formula =
                      (jumlahBarangOK + sisaShiftSebelumnya) / isiPerKemasan;

                    return (
                      <>
                        <div className="wrapper_card_approval_laporan">
                          <div className="section_approval_laporan">
                            <p className="tittle-machine-dashboard">
                              Mesin&nbsp;{data.mesin}
                            </p>
                            <p className="font_bold">{data.customer}</p>
                            <p style={{ textAlign: "end" }}>
                              Shift&nbsp;{data.shift}
                            </p>
                          </div>
                          <div className="flex_justify_between">
                            <p>{data.operator}</p>
                          </div>
                          <div className="flex_justify_between">
                            <p className="font_bold">
                              {data.moldType} - {data.color}
                            </p>
                          </div>
                          <div className="flex_justify_between">
                            <div style={{ width: "40%" }}>
                              <p className="font_bold">Isi PerKemasan</p>
                              <p className="font_14">
                                {data.isiPerKemasan}&nbsp;Pcs
                              </p>
                            </div>
                            <div style={{ width: "50%" }}></div>
                          </div>
                          <div className="flex_justify_between">
                            <div style={{ width: "40%" }}>
                              <p className="font_bold">Jumlah "NG"</p>
                              <p className="font_14">
                                {data.jumlahNG}&nbsp;Pcs
                              </p>
                            </div>
                            <div style={{ width: "50%" }}>
                              <p className="font_bold">
                                Jumlah Barang (Dikali Kemasan)
                              </p>
                              <p className="font_14">
                                {Math.floor(formula) * data.isiPerKemasan}
                                &nbsp;Pcs
                              </p>
                            </div>
                          </div>
                          <div className="flex_justify_between">
                            <div style={{ width: "40%" }}>
                              <p className="font_bold">Receh</p>
                              <div>
                                <p style={{ fontSize: "16px" }}>
                                  <b>
                                    {jumlahBarangOK +
                                      sisaShiftSebelumnya -
                                      Math.floor(formula) * data.isiPerKemasan}
                                  </b>
                                  &nbsp;Pcs
                                </p>
                              </div>
                            </div>
                            <div style={{ width: "50%" }}>
                              <p className="font_bold">
                                Jumlah OK (BOX/KTG/PALET)
                              </p>
                              <div>
                                <p style={{ fontSize: "16px" }}>
                                  <b>{Math.floor(formula)}</b>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })}
              </div>
              {dataLaporanPasangKaret && dataLaporanPasangKaret.length > 0 ? (
                <p className="title_inventory">Laporan Pasang Karet</p>
              ) : (
                ""
              )}
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                {sortDataPasangKaret &&
                  sortDataPasangKaret.map((obj) => {
                    return (
                      <div className="card_approval_top_plate">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <p className="tittle-machine-dashboard">
                            Mesin {obj.mesin}
                          </p>
                          <p style={{ fontWeight: "bold" }}>{obj.operator}</p>
                        </div>
                        <p style={{ fontWeight: "bold" }}>
                          {obj.produk} - {obj.warna}
                        </p>
                        <p>
                          Jumlah Pasang Karet : <b>{obj.jumlah} Pcs</b>
                        </p>
                        <p className="font_bold">Keterangan</p>
                        {obj.keterangan &&
                          obj.keterangan.split("\n").map((subStr) => {
                            return <p>{subStr}</p>;
                          })}
                      </div>
                    );
                  })}
              </div>
            </>
          ) : (
            ""
          )}
        </>
      ) : subMenu === "SP" ? (
        <>
          <div
            className="sticky_filter"
            style={{
              alignItems: "center",
            }}
          >
            <div className="margin_right_27_qc">
              <p className="p-margin-subtittle-dashboard">Pilih Tanggal</p>
              <input
                type="date"
                className="date_pick_dashboard"
                value={dateMonitoringSP}
                onChange={(e) => setDateMonitoringSP(e.target.value)}
              />
            </div>

            {canPilihBagian ? (
              <div style={{ marginRight: "12px" }}>
                <p
                  className="p-margin-subtittle-dashboard"
                  style={{ marginTop: "6px" }}
                >
                  Pilih Bagian
                </p>
                <select
                  className="input_select_filter"
                  value={filterBagian}
                  onChange={(e) => setFilterBagian(e.target.value)}
                >
                  <option selected={filterBagian === "Pilih Bagian"} disabled>
                    Pilih Bagian
                  </option>
                  <option value="SP">Finishing</option>
                  <option value="PR">Printing</option>
                </select>
              </div>
            ) : (
              ""
            )}
            <div style={{ marginRight: "12px" }}>
              <p
                className="p-margin-subtittle-dashboard"
                style={{ marginTop: "6px" }}
              >
                Pilih Produk
              </p>
              <select
                className="input_select_filter"
                value={filterProduk}
                onChange={(e) => setFilterProduk(e.target.value)}
              >
                <option selected={filterProduk === "Pilih Produk"} disabled>
                  Pilih Produk
                </option>

                {filterProdukSelect &&
                  filterProdukSelect.map((data) => (
                    <option value={data}>{data}</option>
                  ))}
              </select>
            </div>
            <div style={{ marginRight: "12px" }}>
              <p
                className="p-margin-subtittle-dashboard"
                style={{ marginTop: "6px" }}
              >
                Pilih Mesin
              </p>
              <select
                className="input_select_filter"
                value={filterMesinSp}
                onChange={(e) => setFilterMesinSp(e.target.value)}
              >
                <option selected={filterMesinSp === "Pilih Mesin"} disabled>
                  Pilih Mesin
                </option>

                {dataUser.tim === 1
                  ? constMesinSP &&
                    constMesinSP.map((data) => (
                      <option value={data}>{data}</option>
                    ))
                  : constMesinSPTim2 &&
                    constMesinSPTim2.map((data) => (
                      <option value={data}>{data}</option>
                    ))}
              </select>
            </div>

            <p className="btn_reset_sp" onClick={() => handleReset()}>
              Reset
            </p>

            {canLaporanBulanan ? (
              <button
                className="button_export_sp"
                style={{ marginRight: "6px" }}
                onClick={() => setPopUpLaporanBulananSP(true)}
              >
                Laporan Bulanan
              </button>
            ) : (
              ""
            )}
            {canLaporanSp ? (
              <button
                className="button_export_sp"
                onClick={() => setIsPopUpExportLaporanSp(true)}
              >
                Laporan SP
              </button>
            ) : (
              ""
            )}
          </div>
          <br />

          <div className="container_card_approval_laporan">
            {sortDataSP &&
              sortDataSP.map((data, index) => {
                return (
                  <div className="card_approval_top_plate">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      {!isEditSP ? (
                        <p
                          className="tittle-machine-dashboard"
                          style={{ margin: "12px 0 6px 0" }}
                        >
                          Mesin {data.mesin}
                        </p>
                      ) : (
                        <>
                          {data.operator === dataUser.name ? (
                            <select
                              style={{ height: "32px", width: "144px" }}
                              name="mesin"
                              value={data.mesin}
                              onChange={(e) =>
                                handleFormChangeSP(index, e, data.id)
                              }
                            >
                              <option
                                selected={data.mesin === "Pilih Mesin"}
                                disabled
                              >
                                Pilih Mesin
                              </option>
                              {constMesinSP &&
                                constMesinSP.map((ele) => (
                                  <option value={ele}>Mesin {ele}</option>
                                ))}
                            </select>
                          ) : (
                            <p
                              className="tittle-machine-dashboard"
                              style={{ margin: "12px 0 6px 0" }}
                            >
                              Mesin {data.mesin}
                            </p>
                          )}
                        </>
                      )}
                      <p style={{ fontWeight: "bold", margin: "12px 0 6px 0" }}>
                        {data && data.operator.split(" ").slice(0, 2).join(" ")}
                      </p>
                      {data.isKepala === false &&
                      dataUser.name === data.operator ? (
                        <img
                          className="width_edit_logo"
                          style={{
                            background: "yellow",
                            borderRadius: "6px",
                          }}
                          onClick={() => setIsEditSP(true)}
                          src={EditLogo}
                          alt="edit_logo"
                        />
                      ) : (
                        ""
                      )}
                    </div>
                    <p style={{ fontWeight: "bold", margin: "6px 0" }}>
                      {data.produk}
                    </p>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      {data.color ? (
                        <p style={{ margin: "6px 0" }}>
                          <b>{data.color}</b>
                        </p>
                      ) : (
                        ""
                      )}
                      <p
                        style={{
                          fontWeight: "bold",
                          fontWeight: "bold",
                          margin: "6px 0",
                        }}
                      >
                        {data.customer}
                      </p>
                      <p
                        style={{
                          fontWeight: "bold",
                          fontWeight: "bold",
                          margin: "6px 0",
                        }}
                      >
                        {data.jenisPekerjaan}
                      </p>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <p
                          style={
                            data && data.jumlahOk + data.reject < data.target
                              ? {
                                  fontWeight: "bold",
                                  color: "red",
                                  margin: "6px 0",
                                }
                              : { fontWeight: "bold", margin: "6px 0" }
                          }
                        >
                          Target (Pcs)
                        </p>
                        <p
                          style={
                            data && data.jumlahOk + data.reject < data.target
                              ? {
                                  fontWeight: "bold",
                                  color: "red",
                                  margin: "6px 0",
                                }
                              : { fontWeight: "bold", margin: "6px 0" }
                          }
                        >
                          {data.target}
                        </p>
                      </div>
                      <div>
                        <p style={{ margin: "6px 0" }}>
                          <b>Bagian</b>
                        </p>
                        <p style={{ margin: "6px 0" }}>{data.bagian}</p>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <p style={{ margin: "6px 0" }}>
                          <b>Reject (Pcs)</b>
                        </p>
                        {!isEditSP ? (
                          <p className="font_14" style={{ margin: "6px 0" }}>
                            <p>{data.reject}</p>
                          </p>
                        ) : (
                          <>
                            {data.operator === dataUser.name ? (
                              <input
                                type="number"
                                style={{ width: "54px" }}
                                className="input_dashboard_operator"
                                name="reject"
                                value={data.reject}
                                onChange={(e) =>
                                  handleFormChangeSP(index, e, data.id)
                                }
                                onWheel={(e) => e.target.blur()}
                              />
                            ) : (
                              <p
                                className="font_14"
                                style={{ margin: "6px 0" }}
                              >
                                <p>{data.reject}</p>
                              </p>
                            )}
                          </>
                        )}
                      </div>
                      {validateRole() === "PR" || validateRole() === "super" ? (
                        <div>
                          <p style={{ margin: "6px 0" }}>
                            <b>Repair (Pcs)</b>
                          </p>
                          {!isEditSP ? (
                            <p className="font_14">
                              <p>{data.repair}</p>
                            </p>
                          ) : (
                            <>
                              {data.operator === dataUser.name ? (
                                <input
                                  type="number"
                                  style={{ width: "54px" }}
                                  className="input_dashboard_operator"
                                  name="repair"
                                  value={data.repair}
                                  onChange={(e) =>
                                    handleFormChangeSP(index, e, data.id)
                                  }
                                  onWheel={(e) => e.target.blur()}
                                />
                              ) : (
                                <p className="font_14">
                                  <p>{data.repair}</p>
                                </p>
                              )}
                            </>
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                      <div>
                        <p style={{ margin: "6px 0" }}>
                          <b>OK (Pcs)</b>
                        </p>
                        {!isEditSP ? (
                          <p className="font_14" style={{ margin: "6px 0" }}>
                            {data.jumlahOk}
                          </p>
                        ) : (
                          <>
                            {data.operator === dataUser.name ? (
                              <input
                                type="number"
                                className="input_dashboard_operator"
                                name="jumlahOk"
                                style={{ width: "54px" }}
                                value={data.jumlahOk}
                                onChange={(e) =>
                                  handleFormChangeSP(index, e, data.id)
                                }
                                onWheel={(e) => e.target.blur()}
                              />
                            ) : (
                              <p
                                className="font_14"
                                style={{ margin: "6px 0" }}
                              >
                                {data.jumlahOk}
                              </p>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <p style={{ margin: "6px 0" }}>
                          <b>Jumlah Pengerjaan</b>
                        </p>
                        {!isEditSP ? (
                          <p className="font_14" style={{ margin: "6px 0" }}>
                            {data.jumlahPengerjaan}
                          </p>
                        ) : (
                          <>
                            {data.operator === dataUser.name ? (
                              <input
                                type="text"
                                className="input_dashboard_operator"
                                name="jumlahPengerjaan"
                                value={data.jumlahPengerjaan}
                                onChange={(e) =>
                                  handleFormChangeSP(index, e, data.id)
                                }
                                onWheel={(e) => e.target.blur()}
                              />
                            ) : (
                              <p
                                className="font_14"
                                style={{ margin: "6px 0" }}
                              >
                                {data.jumlahPengerjaan}
                              </p>
                            )}
                          </>
                        )}
                      </div>
                      {!isOn ? (
                        <div>
                          <p style={{ margin: "6px 0" }}>
                            <b>Downtime</b>
                          </p>
                          <p style={{ margin: "6px 0" }}>
                            {data.downtime} (Menit)
                          </p>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {validateRole() === "PR" || validateRole() === "super" ? (
                      <>
                        <p className="font_bold" style={{ margin: "6px 0" }}>
                          Kind Of Repair
                        </p>
                        <table style={{ width: "100%", fontSize: "14px" }}>
                          <tr>
                            <th style={{ position: "inherit" }}>Repair</th>
                            <th style={{ position: "inherit" }}>Tgl</th>
                            <th
                              style={{
                                padding: "18px 24px 18px 6px",
                                position: "inherit",
                              }}
                            >
                              Total
                            </th>
                          </tr>
                          {data &&
                            data.dataRepair &&
                            data.dataRepair.map((obj, index) => {
                              return (
                                <tr
                                  key={obj.id ?? index}
                                  style={
                                    index % 2 === 0
                                      ? {
                                          background: "white",
                                          fontSize: "12px",
                                        }
                                      : {
                                          background: "#f2f2f2",
                                          fontSize: "12px",
                                        }
                                  }
                                >
                                  <td
                                    style={{
                                      padding: "12px",
                                      textAlign: "left",
                                    }}
                                  >
                                    {obj.id}
                                  </td>
                                  <td style={{ padding: "12px" }}>
                                    {obj.dateRepair}
                                  </td>
                                  <td style={{ padding: "12px" }}>
                                    {obj.repair}
                                  </td>
                                </tr>
                              );
                            })}
                        </table>
                      </>
                    ) : (
                      ""
                    )}
                    <p className="font_bold" style={{ margin: "6px 0" }}>
                      Kind Of Reject
                    </p>
                    <table
                      className="size-keterangan-dashboard"
                      style={{ width: "100%" }}
                    >
                      <tr>
                        <th style={{ position: "inherit" }}>Reject</th>
                        <th style={{ position: "inherit" }}>Tgl</th>
                        <th style={{ position: "inherit" }}>Bagian</th>
                        <th
                          style={{
                            padding: "18px 12px 18px 6px",
                            position: "inherit",
                          }}
                        >
                          Total
                        </th>
                      </tr>
                      {data.dataReject &&
                        data.dataReject.map((obj, index) => {
                          return (
                            <tr
                              style={
                                index % 2 === 0
                                  ? {
                                      background: "white",
                                      fontSize: "12px",
                                    }
                                  : {
                                      background: "#f2f2f2",
                                      fontSize: "12px",
                                    }
                              }
                            >
                              <td
                                style={{ padding: "12px", textAlign: "left" }}
                              >
                                {obj.id}
                              </td>
                              <td style={{ padding: "12px" }}>
                                {obj.dateReject}
                              </td>
                              <td style={{ padding: "12px" }}>
                                {obj.shift ? obj.shift : obj.bagian}
                              </td>
                              <td style={{ padding: "12px" }}>{obj.reject}</td>
                            </tr>
                          );
                        })}
                    </table>

                    <p className="font_bold" style={{ margin: "6px 0" }}>
                      Packing List
                    </p>
                    <div style={{ overflowX: "auto" }}>
                      <table
                        className="size-keterangan-dashboard"
                        style={{ width: "100%" }}
                      >
                        <tr>
                          <th style={{ position: "inherit" }}>Tgl</th>
                          <th style={{ position: "inherit" }}>Mc</th>
                          <th style={{ position: "inherit" }}>Shift</th>
                          <th style={{ position: "inherit" }}>Operator</th>
                          <th style={{ position: "inherit" }}>Jumlah</th>
                          <th
                            style={{
                              padding: "18px 12px 18px 6px",
                              position: "inherit",
                            }}
                          >
                            Keterangan
                          </th>
                        </tr>
                        {data.dataPacking &&
                          data.dataPacking.map((obj, index) => {
                            return (
                              <tr
                                style={
                                  index % 2 === 0
                                    ? {
                                        background: "white",
                                        fontSize: "12px",
                                      }
                                    : {
                                        background: "#f2f2f2",
                                        fontSize: "12px",
                                      }
                                }
                              >
                                <td
                                  style={{
                                    padding: "12px",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {moment(obj.date).format("DD-MM-YYYY")}
                                </td>
                                <td style={{ padding: "12px" }}>{obj.mesin}</td>
                                <td style={{ padding: "12px" }}>{obj.shift}</td>
                                <td style={{ padding: "12px" }}>
                                  {obj.operator}
                                </td>
                                <td style={{ padding: "12px" }}>
                                  {obj.jumlah}
                                </td>
                                <td
                                  className="size-keterangan-dashboard"
                                  style={{ padding: "12px" }}
                                >
                                  {obj.keterangan}
                                </td>
                              </tr>
                            );
                          })}
                      </table>
                    </div>
                    <p className="font_bold" style={{ margin: "6px 0" }}>
                      Keterangan
                    </p>

                    {!isEditSP ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: data.keterangan.replace(/\n/g, "<br/>"),
                        }}
                      />
                    ) : (
                      <>
                        {data.operator === dataUser.name ? (
                          <textarea
                            style={{
                              width: "98%",
                              resize: "none",
                              height: "84px",
                              fontFamily: "arial",
                            }}
                            name="keterangan"
                            value={data.keterangan}
                            onChange={(e) =>
                              handleFormChangeSP(index, e, data.id)
                            }
                          />
                        ) : (
                          <div
                            dangerouslySetInnerHTML={{
                              __html: data.keterangan.replace(/\n/g, "<br/>"),
                            }}
                          />
                        )}
                      </>
                    )}
                  </div>
                );
              })}
          </div>
          {isPrAdmin ? (
            <>
              {dataLaporanPasangStiker && dataLaporanPasangStiker.length > 0 ? (
                <p className="title_inventory">Laporan Pasang Sticker</p>
              ) : (
                ""
              )}
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                {sortDataPasangStiker &&
                  sortDataPasangStiker.map((obj) => {
                    return (
                      <div className="card_approval_top_plate">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <p
                            className="tittle-machine-dashboard"
                            style={{ margin: "12px 0 6px 0" }}
                          >
                            Mesin {obj.mesin}
                          </p>
                          <p
                            style={{
                              fontWeight: "bold",
                              margin: "12px 0 6px 0",
                            }}
                          >
                            {obj.operator}
                          </p>
                        </div>
                        <p style={{ fontWeight: "bold", margin: "6px 0" }}>
                          {obj.produk} - {obj.warna}
                        </p>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: "wrap",
                          }}
                        >
                          <div>
                            <p style={{ margin: "6px 0" }}>
                              <b>Jumlah Pasang</b>
                            </p>
                            <p style={{ margin: "6px 0" }}>{obj.jumlah} Pcs</p>
                          </div>
                          <div>
                            <p style={{ margin: "6px 0" }}>
                              <b>NG Sticker</b>
                            </p>
                            <p style={{ margin: "6px 0" }}>
                              {obj && obj.reject} Pcs
                            </p>
                          </div>
                          <div>
                            <p style={{ margin: "6px 0" }}>
                              <b>NG Produk</b>
                            </p>
                            <p style={{ margin: "6px 0" }}>
                              {obj && obj.rejectProduk} Pcs
                            </p>
                          </div>
                          <div>
                            <p style={{ margin: "6px 0" }}>
                              <b>Downtime</b>
                            </p>
                            <p style={{ margin: "6px 0" }}>
                              {obj.downtime} Menit
                            </p>
                          </div>
                        </div>
                        {obj?.kindOfReject?.length > 0 ? (
                          <div>
                            <p style={{ margin: "6px 0" }}>
                              <b>Ket. Reject Produk</b>
                            </p>
                            <table style={{ width: "100%" }}>
                              <tr>
                                <th style={{ position: "inherit" }}>Shift</th>
                                <th
                                  style={{
                                    position: "inherit",
                                    textAlign: "left",
                                    padding: "18px 0 18px 6px",
                                  }}
                                >
                                  Jenis Reject
                                </th>
                                <th
                                  style={{
                                    padding: "18px 6px",
                                    position: "inherit",
                                  }}
                                >
                                  Reject
                                </th>
                              </tr>
                              {obj.kindOfReject &&
                                obj.kindOfReject.map((ele, index) => {
                                  return (
                                    <tr
                                      style={
                                        index % 2 === 0
                                          ? {
                                              background: "white",
                                              fontSize: "12px",
                                            }
                                          : {
                                              background: "#f2f2f2",
                                              fontSize: "12px",
                                            }
                                      }
                                    >
                                      <td style={{ padding: "12px 6px" }}>
                                        {ele.shift}
                                      </td>
                                      <td
                                        style={{
                                          padding: "12px 0 12px 6px",
                                          textAlign: "left",
                                        }}
                                      >
                                        {ele.id}
                                      </td>
                                      <td style={{ padding: "12px 6px" }}>
                                        {ele.totalNG}
                                      </td>
                                    </tr>
                                  );
                                })}
                            </table>
                          </div>
                        ) : (
                          ""
                        )}
                        <p className="font_bold" style={{ margin: "6px 0" }}>
                          Keterangan
                        </p>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: obj.keterangan.replace(/\n/g, "<br/>"),
                          }}
                          className="size-keterangan-dashboard"
                        />
                      </div>
                    );
                  })}
              </div>
            </>
          ) : (
            ""
          )}

          {isEditSP ? (
            <button
              className="button_submit_memo"
              onClick={() => handleKirimEditSP()}
            >
              Kirim
            </button>
          ) : (
            ""
          )}
        </>
      ) : subMenu === "Approval" ? (
        <>
          <div className="sticky_filter">
            <div className="margin_right_27_qc">
              <p className="p-margin-subtittle-dashboard">Pilih Shift</p>
              <select
                className="input_select_filter"
                value={shiftDashboard}
                onChange={(e) => setShiftDashboard(e.target.value)}
              >
                <option selected={shiftDashboard === "Pilih Shift"} disabled>
                  Pilih Shift
                </option>
                <option value="1">Shift 1</option>
                <option value="2">Shift 2</option>
                <option value="3">Shift 3</option>
              </select>
            </div>
            <div className="margin_right_27_qc">
              <p className="p-margin-subtittle-dashboard">Pilih Tanggal</p>
              <input
                type="date"
                className="date_pick_dashboard"
                value={dateDashboard}
                onChange={(e) => setDateDashboard(e.target.value)}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "end",
              }}
            >
              <img
                src={RefreshIcon}
                alt="refresh"
                style={{
                  width: "36px",
                  margin: "12px 0 12px 0px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setIsRefresh(true);
                }}
              />
            </div>
          </div>
          <div
            className="container_card_approval_laporan"
            style={{
              marginTop: "18px",
            }}
          >
            {sortData &&
              sortData.map((data, index) => {
                const downtime = data.downtime ? data.downtime : 0;
                const dataCounterAwal = data.counterAwal ? data.counterAwal : 0;
                const dataTargetProduk = data.targetProduk
                  ? data.targetProduk
                  : 0;
                const dataAktualCavity = data.aktualCavity
                  ? data.aktualCavity
                  : 0;
                const dataCounterAkhir = data.counterAkhir
                  ? data.counterAkhir
                  : 0;
                const lastCounterAkhir = data.lastCounterAkhir
                  ? data.lastCounterAkhir
                  : 0;

                const formula =
                  (28800 - downtime * 60) /
                  (dataCounterAkhir - dataCounterAwal);

                const formulaTargetProduksi =
                  dataTargetProduk * dataAktualCavity;

                const indicatorCavity =
                  data.jumlahBarang + data.jumlahNG ===
                  (data.counterAkhir - data.counterAwal) * data.aktualCavity;
                const dataSisaShiftSebelumnya = data.sisaShiftSebelumnya
                  ? data.sisaShiftSebelumnya
                  : 0;
                const dataLastSisaShiftSebelumnya =
                  data.lastSisaShiftSebelumnya && dataUser.tim === 1
                    ? data.lastSisaShiftSebelumnya
                    : 0;
                const checkSisaShift =
                  data.jumlahBarang + dataLastSisaShiftSebelumnya ===
                  data.aktualBarang + dataSisaShiftSebelumnya;

                return (
                  <div
                    className="wrapper_card_approval_laporan"
                    style={
                      lastCounterAkhir !== dataCounterAwal && dataUser.tim === 1
                        ? { border: "2px solid red" }
                        : {}
                    }
                  >
                    <div
                      className="section_approval_laporan"
                      style={{
                        margin: "12px 0 6px 0",
                      }}
                    >
                      <p style={{ fontSize: "10px", margin: 0 }}>
                        {dataUser.tim === 1
                          ? "Form-PROD-A28-R2"
                          : "Form-PROD-A28-R8"}
                      </p>
                      <p style={{ fontSize: "10px", margin: 0 }}>
                        {moment(data.dateSubmit).format("HH:mm:ss")}
                      </p>
                    </div>
                    <div className="section_approval_laporan">
                      <p
                        className="tittle-machine-dashboard"
                        style={{ margin: "0 0 6px 0" }}
                      >
                        Mesin&nbsp;{data.mesin}
                      </p>
                      <p
                        className="tittle-customer-dashboard"
                        style={{ margin: "0 0 6px 0" }}
                      >
                        {data.customer}
                      </p>
                      <img
                        style={{
                          width: "24px",
                          cursor: "pointer",
                        }}
                        src={DeleteIcon}
                        alt="delete-icon"
                        onClick={() => handleSetDataDelete(data)}
                      />
                      <img
                        className="width_edit_logo"
                        style={{
                          background: "yellow",
                          borderRadius: "6px",
                          margin: "0 0 6px 0",
                        }}
                        onClick={() => setIsEdit(true)}
                        src={EditLogo}
                        alt="edit_logo"
                      />
                    </div>
                    <div className="flex_justify_between">
                      <p style={{ margin: "6px 0" }}>{data.operator}</p>
                    </div>
                    <div className="flex_justify_between">
                      {!isEdit ? (
                        <p
                          className="font_bold"
                          style={{ margin: "6px 0", fontWeight: "bold" }}
                        >
                          {data.moldType}
                        </p>
                      ) : (
                        <select
                          onChange={(e) => handleChangeMesin(data.id, e)}
                          className="input_select_memo_ppic"
                          style={{ width: "100%", marginTop: "18px" }}
                          name="mold"
                          value={`${data.mesin}|${data.moldType}`}
                        >
                          <option value="" disabled>
                            Pilih Mold Type
                          </option>
                          {dataQc &&
                            dataQc.data.map((e) => (
                              <option
                                key={`${e.mesin}|${e.moldType}`}
                                value={`${e.mesin}|${e.moldType}`}
                              >
                                Mc {e.mesin} - {e.moldType}
                              </option>
                            ))}
                        </select>
                      )}
                    </div>
                    <div className="flex_justify_between">
                      <p style={{ margin: "6px 0" }}>{data.color}</p>
                      <p style={{ margin: "6px 0" }}>
                        {moment(data.date).format("DD MMM YYYY")}
                      </p>
                      <p
                        style={{
                          textAlign: "end",
                          margin: "6px 0",
                        }}
                      >
                        Shift&nbsp;{data.shift}
                      </p>
                    </div>
                    <div className="flex_justify_between">
                      <div style={{ width: "50%" }}>
                        <p
                          style={
                            formulaTargetProduksi > data.jumlahBarang
                              ? {
                                  color: "red",
                                  margin: "6px 0",
                                  fontWeight: "bold",
                                }
                              : { margin: "6px 0", fontWeight: "bold" }
                          }
                        >
                          Target Produksi
                        </p>
                        <p
                          style={
                            formulaTargetProduksi > data.jumlahBarang
                              ? { color: "red", margin: "6px 0" }
                              : { margin: "6px 0" }
                          }
                        >
                          {formulaTargetProduksi.toFixed(0)}
                        </p>
                      </div>
                      <div style={{ width: "40%" }}>
                        <p
                          style={
                            28800 / dataTargetProduk < formula &&
                            28800 / dataTargetProduk !== Infinity
                              ? {
                                  color: "red",
                                  margin: "6px 0",
                                  fontWeight: "bold",
                                }
                              : { margin: "6px 0", fontWeight: "bold" }
                          }
                        >
                          Target CT
                        </p>
                        <p
                          style={
                            28800 / dataTargetProduk < formula &&
                            28800 / dataTargetProduk !== Infinity
                              ? { color: "red", margin: "6px 0" }
                              : { margin: "6px 0" }
                          }
                        >
                          {28800 / dataTargetProduk === Infinity
                            ? 0
                            : (28800 / dataTargetProduk).toFixed(1)}
                          &nbsp;Detik
                        </p>
                      </div>
                    </div>
                    <div className="flex_justify_between">
                      <div style={{ width: "50%" }}>
                        <p
                          className="font_bold"
                          style={{ fontWeight: "bold", margin: "6px 0" }}
                        >
                          Isi Per Kemasan
                        </p>
                        {!isEdit ? (
                          <p className="font_14" style={{ margin: "6px 0" }}>
                            {data.isiPerKemasan}&nbsp;Pcs
                          </p>
                        ) : (
                          <input
                            type="number"
                            className="input_dashboard_operator"
                            name="isiPerKemasan"
                            value={data.isiPerKemasan}
                            onChange={(e) => handleFormChange(index, e)}
                            onWheel={(e) => e.target.blur()}
                          />
                        )}
                      </div>
                      <div style={{ width: "40%" }}>
                        <p
                          className="font_bold"
                          style={{ fontWeight: "bold", margin: "6px 0" }}
                        >
                          Aktual Cavity
                        </p>
                        {!isEdit ? (
                          <p className="font_14" style={{ margin: "6px 0" }}>
                            {data.aktualCavity}
                          </p>
                        ) : (
                          <input
                            type="number"
                            className="input_dashboard_operator"
                            name="aktualCavity"
                            value={data.aktualCavity}
                            onChange={(e) => handleFormChange(index, e)}
                            onWheel={(e) => e.target.blur()}
                          />
                        )}
                      </div>
                    </div>
                    <div className="flex_justify_between">
                      <div style={{ width: "50%" }}>
                        <p
                          className="font_bold"
                          style={{ fontWeight: "bold", margin: "6px 0" }}
                        >
                          Counter Akhir
                        </p>
                        {!isEdit ? (
                          <p className="font_14" style={{ margin: "6px 0" }}>
                            {data.counterAkhir}
                          </p>
                        ) : (
                          <input
                            type="number"
                            className="input_dashboard_operator"
                            name="counterAkhir"
                            value={data.counterAkhir}
                            onChange={(e) => handleFormChange(index, e)}
                            onWheel={(e) => e.target.blur()}
                          />
                        )}
                      </div>
                      <div style={{ width: "40%" }}>
                        <p
                          className="font_bold"
                          style={{ fontWeight: "bold", margin: "6px 0" }}
                        >
                          Counter Awal
                        </p>
                        {!isEdit ? (
                          <p className="font_14" style={{ margin: "6px 0" }}>
                            {data.counterAwal}
                          </p>
                        ) : (
                          <input
                            type="number"
                            className="input_dashboard_operator"
                            name="counterAwal"
                            value={data.counterAwal}
                            onChange={(e) => handleFormChange(index, e)}
                            onWheel={(e) => e.target.blur()}
                          />
                        )}
                      </div>
                    </div>
                    <div className="flex_justify_between">
                      <div style={{ width: "50%" }}>
                        <p
                          className="font_bold"
                          style={{ fontWeight: "bold", margin: "6px 0" }}
                        >
                          Selisih Counter
                        </p>
                        <p className="font_14" style={{ margin: "6px 0" }}>
                          {data.counterAkhir - data.counterAwal}
                        </p>
                      </div>
                      <div style={{ width: "40%" }}>
                        <p
                          className="font_bold"
                          style={{ fontWeight: "bold", margin: "6px 0" }}
                        >
                          Jumlah "NG"
                        </p>
                        <p className="font_14" style={{ margin: "6px 0" }}>
                          {data.jumlahNG}&nbsp;Pcs
                        </p>
                      </div>
                    </div>
                    <div className="flex_justify_between">
                      <div style={{ width: "50%" }}>
                        <p
                          className="font_bold"
                          style={{
                            fontWeight: "bold",
                            margin: "6px 0",
                            color: "lightseagreen",
                          }}
                        >
                          Barang OK
                        </p>
                        {!isEdit ? (
                          <p
                            className="font_14"
                            style={{
                              color: "lightseagreen",
                              margin: "6px 0",
                            }}
                          >
                            {data.jumlahBarang}&nbsp;Pcs
                          </p>
                        ) : (
                          <input
                            type="number"
                            className="input_dashboard_operator"
                            name="jumlahBarang"
                            value={data.jumlahBarang}
                            onChange={(e) => handleFormChange(index, e)}
                            onWheel={(e) => e.target.blur()}
                          />
                        )}
                      </div>
                      <div
                        style={
                          !indicatorCavity
                            ? { width: "40%", color: "red" }
                            : { width: "40%" }
                        }
                      >
                        <p
                          className="font_bold"
                          style={{ fontWeight: "bold", margin: "6px 0" }}
                        >
                          Indikator Laporan
                        </p>
                        <p className="font_14" style={{ margin: "6px 0" }}>
                          {!indicatorCavity ? "SALAH" : ""}
                        </p>
                      </div>
                    </div>
                    <div className="flex_justify_between">
                      <div style={{ width: "50%" }}>
                        <p
                          className="font_bold"
                          style={
                            dataLastSisaShiftSebelumnya > 0
                              ? checkSisaShift && dataUser.tim === 1
                                ? { margin: "6px 0", fontWeight: "bold" }
                                : {
                                    margin: "6px 0",
                                    fontWeight: "bold",
                                    color: "red",
                                  }
                              : { margin: "6px 0", fontWeight: "bold" }
                          }
                        >
                          {dataUser.tim === 2
                            ? "Sisa Shift Sebelumnya"
                            : `Receh Shift ${data.shift}`}
                        </p>
                        {!isEdit ? (
                          <p
                            className="font_14"
                            style={
                              dataLastSisaShiftSebelumnya > 0
                                ? checkSisaShift && dataUser.tim === 1
                                  ? { margin: "12px 0 6px 0" }
                                  : {
                                      margin: "12px 0 6px 0",
                                      color: "red",
                                    }
                                : { margin: "12px 0 6px 0" }
                            }
                          >
                            {data.sisaShiftSebelumnya}&nbsp;Pcs
                          </p>
                        ) : (
                          <input
                            type="number"
                            className="input_dashboard_operator"
                            name="sisaShiftSebelumnya"
                            value={data.sisaShiftSebelumnya}
                            onChange={(e) => handleFormChange(index, e)}
                            onWheel={(e) => e.target.blur()}
                          />
                        )}
                      </div>
                    </div>
                    <div className="flex_justify_between">
                      <div style={{ width: "50%" }}>
                        <p
                          className="font_bold"
                          style={{ fontWeight: "bold", margin: "6px 0" }}
                        >
                          Down Time
                        </p>
                        {!isEdit ? (
                          <p className="font_14" style={{ margin: "6px 0" }}>
                            {downtime}&nbsp;Menit
                          </p>
                        ) : (
                          <input
                            type="number"
                            className="input_dashboard_operator"
                            name="downtime"
                            value={data.downtime}
                            onChange={(e) => handleFormChange(index, e)}
                            onWheel={(e) => e.target.blur()}
                          />
                        )}
                      </div>
                      <div style={{ width: "40%" }}>
                        <p
                          className="font_bold"
                          style={{ fontWeight: "bold", margin: "6px 0" }}
                        >
                          Cycle Time
                        </p>
                        <p className="font_14" style={{ margin: "6px 0" }}>
                          {formula === Infinity ? 0 : formula.toFixed(1)}
                          &nbsp;Detik
                        </p>
                      </div>
                    </div>
                    {dataUser.tim === 2 ? (
                      <div className="flex_justify_between">
                        <div style={{ minWidth: "148px" }}>
                          <p style={{ margin: "6px 0" }}>Produk OK + SISA</p>
                          <p style={{ margin: "6px 0" }}>
                            {Number(data.jumlahBarang) +
                            Number(data.sisaShiftSebelumnya)
                              ? Number(data.jumlahBarang) +
                                Number(data.sisaShiftSebelumnya)
                              : 0}
                          </p>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="flex_justify_between">
                      <div style={{ width: "50%" }}>
                        <p
                          className="font_bold"
                          style={{ margin: "6px 0", fontWeight: "bold" }}
                        >
                          Aktual Barang
                        </p>
                        {!isEdit ? (
                          <p
                            className="font_14"
                            style={{ margin: "12px 0 6px 0" }}
                          >
                            {data.aktualBarang}&nbsp;Pcs
                          </p>
                        ) : (
                          <input
                            type="number"
                            className="input_dashboard_operator"
                            name="aktualBarang"
                            value={data.aktualBarang}
                            onChange={(e) => handleFormChange(index, e)}
                            onWheel={(e) => e.target.blur()}
                          />
                        )}
                      </div>
                      {dataUser.tim === 2 ? (
                        <div style={{ width: "40%" }}>
                          <p style={{ margin: "6px 0", fontWeight: "bold" }}>
                            Selisih Barang
                          </p>
                          <p style={{ margin: "12px 0 6px 0" }}>
                            {data.aktualBarang
                              ? Number(data.aktualBarang) -
                                Number(data.jumlahBarang) -
                                Number(data.sisaShiftSebelumnya)
                              : 0}
                            &nbsp;Pcs
                          </p>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div>
                      <div className="flex_justify_between">
                        <p
                          style={{
                            width: "50%",
                            fontWeight: "bold",
                            margin: "6px 0",
                          }}
                        >
                          Perincian "NG"
                        </p>
                        <p
                          style={{
                            width: "40%",
                            fontWeight: "bold",
                            margin: "6px 0",
                          }}
                        >
                          Jumlah
                        </p>
                      </div>
                      {data.perincianNG &&
                        data.perincianNG.map((perincian) => {
                          return (
                            <div className="flex_justify_between">
                              <p
                                className="size-keterangan-dashboard"
                                style={{
                                  width: "50%",
                                  margin: "6px 0",
                                }}
                              >
                                {perincian.id}
                              </p>
                              <p
                                className="size-keterangan-dashboard"
                                style={{
                                  width: "40%",
                                  margin: "6px 0",
                                }}
                              >
                                {perincian.totalNG}&nbsp;Pcs
                              </p>
                            </div>
                          );
                        })}

                      {data.keterangan !== "" || dataUser.tim === 2 ? (
                        <div>
                          <p
                            className="font_bold"
                            style={{ fontWeight: "bold", margin: "6px 0" }}
                          >
                            Keterangan
                          </p>
                          {!isEdit ? (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: data.keterangan.replace(/\n/g, "<br/>"),
                              }}
                            />
                          ) : (
                            <textarea
                              style={{
                                width: "98%",
                                resize: "none",
                                height: "84px",
                                fontFamily: "arial",
                              }}
                              name="keterangan"
                              value={data.keterangan}
                              onChange={(e) => handleFormChange(index, e)}
                            />
                          )}
                        </div>
                      ) : (
                        <>
                          <div
                            style={{
                              width: "100%",
                            }}
                          >
                            <table
                              style={{
                                width: "100%",
                              }}
                            >
                              <tr>
                                <th
                                  style={{
                                    padding: "8px 0px 8px 12px",
                                    textAlign: "left",
                                    fontSize: "12px",
                                    position: "static",
                                  }}
                                >
                                  Jam
                                </th>
                                <th
                                  style={{
                                    padding: "8px 0px 8px 12px",
                                    textAlign: "left",
                                    fontSize: "12px",
                                    position: "static",
                                  }}
                                >
                                  Keterangan
                                </th>
                              </tr>

                              {data.dataKeterangan.map((ele, i) => {
                                return (
                                  <tr>
                                    <td
                                      style={{
                                        textAlign: "left",
                                        paddingLeft: "10px",
                                        paddingTop: "8px",
                                        whiteSpace: "nowrap",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {!isEdit ? (
                                        <>{ele.jam}</>
                                      ) : (
                                        <>
                                          <input
                                            style={{
                                              width: "72px",
                                              fontSize: "12px",
                                            }}
                                            type="text"
                                            name="jam"
                                            value={ele.jam}
                                            onChange={(event) =>
                                              handleFormChange(
                                                index,
                                                event,
                                                "dataKeterangan",
                                                i
                                              )
                                            }
                                          />
                                        </>
                                      )}
                                    </td>
                                    <td
                                      style={{
                                        textAlign: "left",
                                        paddingLeft: "10px",
                                        paddingTop: "8px",
                                        wordBreak: "break-all",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {!isEdit ? (
                                        <>{ele.keterangan}</>
                                      ) : (
                                        <>
                                          <textarea
                                            style={{
                                              width: "97%",
                                              fontSize: "12px",
                                              minHeight: "32px",
                                              resize: "none",
                                            }}
                                            name="keterangan"
                                            value={ele.keterangan}
                                            onChange={(event) =>
                                              handleFormChange(
                                                index,
                                                event,
                                                "dataKeterangan",
                                                i
                                              )
                                            }
                                          />
                                        </>
                                      )}
                                    </td>
                                  </tr>
                                );
                              })}
                            </table>
                            {!isEdit ? (
                              <div
                                className="container_button_tambah"
                                style={{
                                  display: "flex",
                                  justifyContent: "end",
                                  marginTop: "12px",
                                }}
                              >
                                <div>
                                  <button
                                    className="button_plus"
                                    style={{
                                      marginRight: "16px",
                                      cursor: "pointer",
                                    }}
                                    onClick={(event) =>
                                      handleFormChange(index, event, "kurang")
                                    }
                                  >
                                    &#8722;
                                  </button>
                                  <button
                                    className="button_plus"
                                    style={{ cursor: "pointer" }}
                                    onClick={(event) =>
                                      handleFormChange(index, event, "tambah")
                                    }
                                  >
                                    &#43;
                                  </button>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                );
              })}
          </div>
          {dataLaporanPasangKaret && dataLaporanPasangKaret.length > 0 ? (
            <p className="title_inventory">Laporan Pasang Karet</p>
          ) : (
            ""
          )}
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {sortDataPasangKaret &&
              sortDataPasangKaret.map((obj, index) => {
                return (
                  <div className="card_approval_top_plate">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <p className="tittle-machine-dashboard">
                        Mesin {obj.mesin}
                      </p>
                      <img
                        style={{ width: "24px", cursor: "pointer" }}
                        src={DeleteIcon}
                        alt="delete-icon"
                        onClick={() => handleSetDataDeletePasangKaret(obj)}
                      />
                      <img
                        className="width_edit_logo"
                        style={{
                          background: "yellow",
                          borderRadius: "6px",
                        }}
                        onClick={() => setIsEdit(true)}
                        src={EditLogo}
                        alt="edit_logo"
                      />
                    </div>
                    <p style={{ fontWeight: "bold" }}>
                      {obj.produk} - {obj.warna}
                    </p>
                    <p>{obj.operator}</p>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <p>
                          <b>Jumlah Pasang Karet</b>
                        </p>
                        {!isEdit ? (
                          <p>{obj.jumlah} Pcs</p>
                        ) : (
                          <input
                            type="number"
                            className="input_dashboard_operator"
                            name="jumlah"
                            value={obj.jumlah}
                            onChange={(e) =>
                              handleFormChangePasangKaret(index, e)
                            }
                            onWheel={(e) => e.target.blur()}
                          />
                        )}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div style={{ width: "50%" }}>
                        <p>
                          <b>Downtime</b>
                        </p>
                        {!isEdit ? (
                          <p>{obj.downtime} Menit</p>
                        ) : (
                          <input
                            type="number"
                            className="input_dashboard_operator"
                            name="downtime"
                            value={obj.downtime}
                            onChange={(e) =>
                              handleFormChangePasangKaret(index, e)
                            }
                            onWheel={(e) => e.target.blur()}
                          />
                        )}
                      </div>
                      <div style={{ width: "40%" }}>
                        <p>
                          <b>Aktual Cavity</b>
                        </p>
                        {!isEdit ? (
                          <p>{obj.aktualCavity ? obj.aktualCavity : ""}</p>
                        ) : (
                          <input
                            type="number"
                            className="input_dashboard_operator"
                            name="aktualCavity"
                            value={obj.aktualCavity}
                            onChange={(e) =>
                              handleFormChangePasangKaret(index, e)
                            }
                            onWheel={(e) => e.target.blur()}
                          />
                        )}
                      </div>
                    </div>
                    <p className="font_bold">Keterangan</p>
                    {obj.keterangan &&
                      obj.keterangan.split("\n").map((subStr) => {
                        return <p>{subStr}</p>;
                      })}
                  </div>
                );
              })}
          </div>
          {dataLaporanPasangStiker && dataLaporanPasangStiker.length > 0 ? (
            <p className="title_inventory">Laporan Pasang Sticker</p>
          ) : (
            ""
          )}
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {sortDataPasangStiker &&
              sortDataPasangStiker.map((obj, index) => {
                return (
                  <div className="card_approval_top_plate">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <p
                        className="tittle-machine-dashboard"
                        style={{ margin: "12px 0 6px 0" }}
                      >
                        Mesin {obj.mesin}
                      </p>
                      <img
                        style={{
                          width: "24px",
                          cursor: "pointer",
                          margin: "12px 0 6px 0",
                        }}
                        src={DeleteIcon}
                        alt="delete-icon"
                        onClick={() => handleSetDataDeletePasangSticker(obj)}
                      />
                      <img
                        className="width_edit_logo"
                        style={{
                          background: "yellow",
                          borderRadius: "6px",
                          margin: "12px 0 6px 0",
                        }}
                        onClick={() => setIsEdit(true)}
                        src={EditLogo}
                        alt="edit_logo"
                      />
                    </div>
                    <p style={{ margin: "6px 0" }}>{obj.operator}</p>
                    <p style={{ fontWeight: "bold", margin: "6px 0" }}>
                      {obj.produk} - {obj.warna}
                    </p>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      <div>
                        <p style={{ margin: "6px 0" }}>
                          <b>Jumlah Pasang</b>
                        </p>
                        {!isEdit ? (
                          <p style={{ margin: "6px 0" }}>{obj.jumlah} Pcs</p>
                        ) : (
                          <input
                            type="number"
                            className="input_dashboard_operator"
                            name="jumlah"
                            value={obj.jumlah}
                            onChange={(e) =>
                              handleFormChangePasangSticker(index, e)
                            }
                            onWheel={(e) => e.target.blur()}
                          />
                        )}
                      </div>
                      <div>
                        <p style={{ margin: "6px 0" }}>
                          <b>NG Sticker</b>
                        </p>
                        <p style={{ margin: "6px 0" }}>
                          {obj && obj.reject} Pcs
                        </p>
                      </div>
                      <div>
                        <p style={{ margin: "6px 0" }}>
                          <b>NG Produk</b>
                        </p>
                        <p style={{ margin: "6px 0" }}>
                          {obj && obj.rejectProduk} Pcs
                        </p>
                      </div>
                      <div>
                        <p style={{ margin: "6px 0" }}>
                          <b>Downtime</b>
                        </p>
                        {!isEdit ? (
                          <p style={{ margin: "6px 0" }}>
                            {obj.downtime} Menit
                          </p>
                        ) : (
                          <input
                            type="number"
                            className="input_dashboard_operator"
                            name="downtime"
                            value={obj.downtime}
                            onChange={(e) =>
                              handleFormChangePasangSticker(index, e)
                            }
                            onWheel={(e) => e.target.blur()}
                          />
                        )}
                      </div>
                    </div>
                    {obj?.kindOfReject?.length > 0 ? (
                      <div>
                        <p style={{ margin: "6px 0" }}>
                          <b>Ket. Reject Produk</b>
                        </p>
                        <table style={{ width: "100%" }}>
                          <tr>
                            <th style={{ position: "inherit" }}>Shift</th>
                            <th
                              style={{
                                position: "inherit",
                                textAlign: "left",
                                padding: "18px 0 18px 6px",
                              }}
                            >
                              Jenis Reject
                            </th>
                            <th
                              style={{
                                padding: "18px 6px",
                                position: "inherit",
                              }}
                            >
                              Reject
                            </th>
                          </tr>
                          {obj.kindOfReject &&
                            obj.kindOfReject.map((ele, index) => {
                              return (
                                <tr
                                  style={
                                    index % 2 === 0
                                      ? {
                                          background: "white",
                                          fontSize: "12px",
                                        }
                                      : {
                                          background: "#f2f2f2",
                                          fontSize: "12px",
                                        }
                                  }
                                >
                                  <td style={{ padding: "12px 6px" }}>
                                    {ele.shift}
                                  </td>
                                  <td
                                    style={{
                                      padding: "12px 0 12px 6px",
                                      textAlign: "left",
                                    }}
                                  >
                                    {ele.id}
                                  </td>
                                  <td style={{ padding: "12px 6px" }}>
                                    {ele.totalNG}
                                  </td>
                                </tr>
                              );
                            })}
                        </table>
                      </div>
                    ) : (
                      ""
                    )}
                    <p className="font_bold" style={{ margin: "6px 0" }}>
                      Keterangan
                    </p>
                    {!isEdit ? (
                      <>
                        {obj.keterangan &&
                          obj.keterangan.split("\n").map((subStr) => {
                            return <p>{subStr}</p>;
                          })}
                      </>
                    ) : (
                      <textarea
                        style={{
                          width: "98%",
                          resize: "none",
                          height: "84px",
                          fontFamily: "arial",
                        }}
                        name="keterangan"
                        value={obj.keterangan}
                        onChange={(e) =>
                          handleFormChangePasangSticker(index, e)
                        }
                      />
                    )}
                  </div>
                );
              })}
          </div>
          {listTopPlate && listTopPlate.length > 0 ? (
            <p className="title_inventory">Laporan Pasang Top Plate</p>
          ) : (
            ""
          )}
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {listTopPlate &&
              listTopPlate.map((obj) => {
                return (
                  <div className="card_approval_top_plate">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <p
                        className="tittle-machine-dashboard"
                        style={{ margin: "12px 0 6px 0" }}
                      >
                        Mesin {obj.mesin}
                      </p>
                      <p
                        style={{
                          fontWeight: "bold",
                          margin: "12px 0 6px 0",
                        }}
                      >
                        {obj.operator}
                      </p>
                    </div>
                    <p style={{ fontWeight: "bold", margin: "6px 0" }}>
                      {obj.produk}
                    </p>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <p style={{ margin: "6px 0" }}>
                          <b>Jumlah Pasang</b>
                        </p>
                        <p style={{ margin: "6px 0" }}>{obj.jumlah} Pcs</p>
                      </div>
                      <div>
                        <p style={{ margin: "6px 0" }}>
                          <b>Downtime</b>
                        </p>
                        <p style={{ margin: "6px 0" }}>{obj.downtime} Menit</p>
                      </div>
                    </div>
                    <p className="font_bold" style={{ margin: "6px 0" }}>
                      Keterangan
                    </p>
                    {obj.keterangan &&
                      obj.keterangan.split("\n").map((subStr) => {
                        return <p>{subStr}</p>;
                      })}
                  </div>
                );
              })}
          </div>
          {(historyDataOperator && historyDataOperator.length > 0) ||
          isEdit ||
          (dataLaporanPasangKaret && dataLaporanPasangKaret.length > 0) ||
          (dataLaporanPasangStiker && dataLaporanPasangStiker.length > 0) ? (
            <button
              className="button_submit_memo"
              onClick={() => handleKirimEditAdmin()}
            >
              Kirim
            </button>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}
    </div>
  );
};
export default Dashboard;
